import { Guest } from "../types";
import Link from "next/link";
import Image from "next/image";
import { getImage } from "../utils";
import { HeadingHr } from "./heading-hr";

export function GuestList(o: { guests: Guest[], title: string, showAllGuests: boolean }) {
  const { guests, title, showAllGuests } = o;

  return (guests.length > 0) && (
    <section className="mb-10">
      <HeadingHr title={title} />

      <div className="max-w-[1200px] mx-auto pt-4">
        <div className="grid grid-cols-1 gap-4 xl:gap-7 md:grid-cols-2 xl:grid-cols-3">
          {guests.map(guest => (
            <Link key={guest.slug} href={`/guests/${guest.slug}`} className="block">
              <div className="flex flex-start gap-2 xl:gap-6">
                <div className="flex-shrink-0
                  max-w-[60px] lg:max-w-[80px] xl:max-w-[96px]">
                  <Image
                    src={getImage(guest, "image", "small")}
                    alt={guest.name}
                    width={96}
                    height={96}
                    className="object-cover rounded-md lg:rounded-[10px]"
                  />
                </div>
                <div className="flex flex-col items-start justify-center gap-1 text-left">
                  <div className="text-lg lg:text-xl xl:text-2xl font-medium font-heading text-black">{guest.name}</div>
                  <div className="text-base md:text-sm lg:text-base xl:text-lg font-body text-black tracking-tight leading-tight">{guest.institution}</div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {showAllGuests &&
          <Link href="/guests" className="flex justify-end font-body text-lg xl:text-2xl underline mt-8">
            all guests
        </Link>}
      </div>
    </section>
  )
}